const ApplicationEvents = require('utils/framework/ApplicationEvents');

class Application {
    static events = ApplicationEvents;
}

module.exports = Application;
